module.exports = __webpack_public_path__ + "static/img/applySuccess.0465304f.png";